import * as FingerprintJS from '@fingerprintjs/fingerprintjs-pro'
import { Logger } from '@egw/logger'
import { isValidConfig } from '@egw/config'
import { notifications, NOTIFICATIONS } from '@egw/notifications'
import { type Config, configSchema } from '../../config/config'

const log = new Logger('Device Service - FingerprintJS')

let instance: DeviceService | null = null

class DeviceService {
  private deviceData: FingerprintJS.ExtendedGetResult | undefined

  constructor() {
    if (!instance) {
      instance = this
    }
  }

  initDeviceService = async (config: Config): Promise<void> => {
    if (!isValidConfig(config, configSchema)) {
      log.error('FingerprintJS configuration is invalid')
      throw new Error('FingerprintJS configuration is invalid')
    }
    if (!this.deviceData) {
      const { apiKey, endpoint, agentDownloadPath, agentGetResultPath, agentBehaviorPath } = config.fingerprintJs

      const fingerPrintScriptUrlPattern = `${endpoint}/${agentBehaviorPath}/${agentDownloadPath}?apiKey=<apiKey>&version=<version>&loaderVersion=<loaderVersion>`
      const fingerPrintEndpoint = `${endpoint}/${agentBehaviorPath}/${agentGetResultPath}?region=us`

      const fpConfig: FingerprintJS.LoadOptions = {
        apiKey,
        scriptUrlPattern: [fingerPrintScriptUrlPattern],
        endpoint: [fingerPrintEndpoint],
      }

      const client = await FingerprintJS.load(fpConfig)
      this.deviceData = await client.get({ extendedResult: true })

      notifications.dispatch(NOTIFICATIONS.DEVICE.DATA, this.deviceData)

      log.info('FingerprintJS is initialized')
    } else {
      log.warn('FingerprintJS has already been initialized. Skipping initialization...')
    }
  }

  getDeviceData = (): FingerprintJS.ExtendedGetResult | undefined => {
    return this.deviceData
  }
}

export const deviceService = new DeviceService()
